export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const MARK_NOTIFICATION_READ = 'MARK_NOTIFICATION_READ';
export const MARK_ALL_AS_READ = 'MARK_ALL_AS_READ';
export const RECEIVE_PUSH_NOTIFICATION = 'RECEIVE_PUSH_NOTIFICATION';
export const TOGGLE_DO_NOT_DISTURB = 'TOGGLE_DO_NOT_DISTURB';
export const INITIALIZE_DO_NOT_DISTURB = 'INITIALIZE_DO_NOT_DISTURB';
